module.exports = __webpack_public_path__ + "img/opened-eye.48c0d6ca.svg";